import { Page } from '../../types'

const fraudInvestigations: Page[] = [
    {
        pageType: 'question',
        title: 'Fraud Investigations',
        name: 'fraud-investigations',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'How many investigations were brought forward?',
                name: 'fraud-investigations-brought-forward',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many investigations were opened?',
                name: 'fraud-investigations-opened',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many investigations were closed?',
                name: 'fraud-investigations-closed',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many investigations were ongoing?',
                name: 'fraud-investigations-ongoing',
                hint: 'Total number of instances',
                rules: {
                  required: false
                },
                autofillMath: {
                  expression: 'a + b - c',
                  fields: {
                    a: 'fraud-investigations-brought-forward',
                    b: 'fraud-investigations-opened',
                    c: 'fraud-investigations-closed'
                  }
                }
              },
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'fraud-investigations-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default fraudInvestigations
